import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { baseQuery } from './customFetchBase'

export const publicAPI = createApi({
  reducerPath: 'publicAPI',
  baseQuery: baseQuery,
  endpoints: () => ({}),
})
